import React from 'react';

import { Root } from './App';

interface ClientRoot {
  render(children: React.ReactNode): void;
}

/** Mount the application through its single root. */
export function renderClientRoot(root: ClientRoot): void {
  root.render(<Root />);
}
